/** Menü/footer bağlantısı dış adres mi (http:// ya da https:// ile başlar)? Site içi yollar "/" ile başlar. */
export function isExternalHref(href: string): boolean {
  return /^https?:\/\//i.test(href);
}

/**
 * Zengin metindeki bağlantı adresi güvenli mi? Backend `RichTextSanitizer` ile aynı kural:
 * adreste `\`, boşluk ya da kontrol karakteri (U+0000–U+0020, U+007F) olamaz; site içi adres `/` ile
 * başlar ve ikinci karakteri `/` ya da `\` olamaz (protokol-göreli `//evil.com`); dışarıya yalnız
 * `http(s)://`, `mailto:` ve `tel:` açılır.
 */
export function isSafeHref(href: string): boolean {
  // eslint-disable-next-line no-control-regex
  if (/[\u0000- \u007F\\]/.test(href)) return false;
  if (href.startsWith('/')) return href[1] !== '/';
  return /^(https?:\/\/|mailto:|tel:)/i.test(href);
}

/** Menü bağlantısında tıklanmaması gereken adres: görünmez Unicode biçim karakteri, `javascript:`/`data:`. */
export function isSuspiciousMenuHref(href: string): boolean {
  return (
    /[\u200B-\u200F\u202A-\u202E\u2060-\u2069\uFEFF]/.test(href) ||
    // eslint-disable-next-line no-control-regex
    /^[\u0000- ]*(javascript|data|vbscript):/i.test(href)
  );
}
